import { computed, ref } from 'vue';

export function useFormDirtyState() {
  const dirtyStates = ref<{ [key: string]: boolean }>({});

  const handleDirtyState = (field: string) => (isDirty: boolean) => {
    dirtyStates.value[field] = isDirty;
  };

  const isAnyFieldDirty = computed(() => {
    return Object.values(dirtyStates.value).includes(true);
  });

  return { isAnyFieldDirty, handleDirtyState };
}
